import * as React  from 'react';
import { useRef } from 'react';
import FileView from '../../../../components/FileView';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
const moment =require('moment');
const classnames = require('classnames');
import 'react-viewer/dist/index.css';
import { StringConstants, CharConstants } from "../../../../containers/WorkkardDetail/constants";
;

import {updateFileCaption,showTooltip,hideTooltip,} from '../../../../containers/WorkkardDetail/actions/action';
import { TOOLTIP_DELAY_TIME } from '../../../SpockViewPage/constants';
import UserMiniProfile from '../../../../components/UserMiniProfile';
import {abbreviationName} from '../../../../common/util';
import UserImage from '../../../../components/UserImage/index';
import { selectUserById } from '../../../../common/slice/userList';
import { selectOrgById } from '../../../../common/slice/orgList';

function FileCell(props){
    const { data } = props;
    const timeOut = useRef(null);

    function handleCheckboxChange(isChecked,file){
        props.onItemClick(isChecked,file)
    }

    function handleDownloadAllCellFiles(file){
        props.onCellClick(true,file)
    }

    function openMiniProfile(targetRect) {
        const userId = props.data.UserId;
        if (userId) {
            props.showTooltip({
                delay: TOOLTIP_DELAY_TIME,
                target: targetRect,
                childComponent: <UserMiniProfile userId={userId}/>,
            });
        }
    }

    function onMouseEnter(e) {
        const targetRect = e.currentTarget.getBoundingClientRect();
        timeOut.current = setTimeout(() => openMiniProfile(targetRect),500)
    }

    function onMouseLeave() {
        clearTimeout(timeOut.current)
    }

    function openTooltip(event,tooltipData){
        props.showTooltip({
            target: event.target.getBoundingClientRect(),
            hideOnDocClick: false,
            childComponent: <span>{tooltipData}</span>
        });
    }

    const classnameFileCell={
        "fileAttachment":true,
        "largeView":props.largeView
    }

    return (
        <div className="filesListing detailListing" key={data.Id}>
            <div className="filesCreatedDate detailCreatedDate" onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
               <UserImage  profileUrl={data.ProfileImage} className="profilePic" profileName={props.userName}/>

                {/* {data.UploadedDateString} */}
            </div>
            <div className="noteRightBlock detailRightBlock">
                <div className="notesDescription detailDescription">
                    <div className="rowSpaceBetween mb">
                        <span className="userInfo flexWrap alignMiddle">
                            {props.userName} <span className="mr__4 ml__4">&ndash;</span> <span onMouseEnter={(e) => openTooltip(e,props.orgName)}>{abbreviationName(props.orgName)}</span>
                            <span className="dateTime">
                                <label className="mrNone">{data.UploadedDateString.split('at')[1]}</label>
                            </span>
                            {
                                data.Ftype == StringConstants.workkard.toUpperCase() ?
                                    <span className="status wkNumber"><span className="badges wkSymbol mr ml__12">{CharConstants.Workkard}</span></span>
                                    :
                                    <span className="badges actSymbol mr ml__12">{CharConstants.Activity}</span>
                            }
                            {
                                (props.globalSearch==3) && <a href={ data.Ftype == StringConstants.workkard.toUpperCase() ? `/getclmdetail?cId=${data.ParentUrl}` : `/gad?actId=${data.ParentUrl}`} className="rowFlex alignMiddle"><span className="status">{data.ActivityName}</span></a>
                            }
                        </span>

                        <span className={`status ${data.Type && data.Type.replace('Personal', 'Draft').toLowerCase()}`}>{data.Type && data.Type.replace('Personal', 'Draft')}</span>
                    </div>
                </div>
                <div className={classnames(classnameFileCell)}>
                    <FileView  updateFileCaption={(fileData)=>{
                        props.updateFileCaption(fileData);
                    }} fileData={data} handleCheckboxChange={handleCheckboxChange} extraData={props.extraData} isSelectAll={props.isSelectAll}  galleryData={props.galleryData} EditableMode={true}/>
                    {
                        !(props.globalSearch==3)?
                        <span className="mt__1 alignRight flexGrow downloadAll"><a href="javascript:void(0)" onClick={()=>handleDownloadAllCellFiles(data.Files)}>Download all</a></span>
                         :
                         null
                    }

                </div>
            </div>

        </div>
    );
}

const mapStateToProps = (state, ownProps) => {
    const fileUser = selectUserById(ownProps.data && ownProps.data.UserId)(state);
    const fileOrg = selectOrgById(ownProps.data && ownProps.data.OrgId)(state);
    return {
        largeView: state.workkardDetail.middlePanel.files.largeView,
        isSelectAll: state.workkardDetail.middlePanel.files.isSelectAll,
        galleryData : state.workkardDetail.middlePanel.files.galleryData,
        globalSearch:state.header.globalSearch.activeTab,
        userName: (fileUser && (`${fileUser.first_name || ''} ${fileUser.last_name || ''}`.trim() || fileUser.user_name)) || (ownProps.data && ownProps.data.Name),
        orgName: (fileOrg?.name) || (ownProps?.data?.OrganizationName)
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateFileCaption: bindActionCreators(updateFileCaption, dispatch),
    showTooltip: bindActionCreators(showTooltip, dispatch),
    hideTooltip: bindActionCreators(hideTooltip, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FileCell);
